import { useAuth } from "../../../auth/authContext";
import { ApplicationSectionHeader, ApplicationStateRegion } from "../../../components/application";
import useFacilitatorProjects from "../hooks/useFacilitatorProjects";
import ProjectFacilitationCard from "./ProjectFacilitationCard";

export default function ProjectFacilitationSection() {
  const { user } = useAuth();
  const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5001/api";
  const { projects, loading, error } = useFacilitatorProjects({ token: user?.token, apiUrl });
  return (
    <section aria-labelledby="facilitator-projects-title" className="av-facilitator-projects">
      <ApplicationSectionHeader
        description="Open Projects you are authorized to oversee."
        title="Your projects"
        titleId="facilitator-projects-title"
      />
      {loading ? <ApplicationStateRegion message="Loading facilitator projects..." status="loading" /> : null}
      {error ? <ApplicationStateRegion message={error} status="error" /> : null}
      {!loading && !error && projects.length === 0 ? (
        <ApplicationStateRegion message="No projects are currently available for facilitation." status="empty" />
      ) : null}
      {!loading && !error && projects.length ? (
        <div className="av-facilitator-projects__grid">
          {projects.map((project) => <ProjectFacilitationCard key={project.id} project={project} />)}
        </div>
      ) : null}
    </section>
  );
}
